import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'; 
import axios from 'axios';
import { DEFAULT_API_URL } from './apiService'; 
import './Caller.css';

const CallItemImportant = ({ name, showing, queue_type }) => {
  return (
    <div style={{
      minHeight: "50vh",
      minWidth: "90vw",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 50,
      background: "linear-gradient(to bottom, white, #30beca, #fbcd00)",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
      fontSize: "10vw",
      color: "white",
      animation: `fadeInOut ${showing || '6'}s ease-in-out`,
      position: "absolute",
      zIndex: "1",
    }}>
      <div>CAJA
      <span style={{
        fontSize: "20vw",
        color: "white",
        margin: "0 100px",
      }}>{name}</span>
      LIBRE<br/>
      Fila {queue_type}</div>
    </div>
  );
}

// Aceptamos storeIdProp como propiedad opcional
const Caller = ({ storeIdProp }) => {
  const params = useParams();
  
  // LOGS DE DEPURACIÓN
  // Verificamos qué estamos recibiendo
  // console.log("Caller Debug - Prop:", storeIdProp, "Params:", params);

  // Prioridad: 1. Prop (usuario logueado), 2. URL Params (Kiosco público)
  const storeId = storeIdProp || params.storeId; 

  const [llamadas, setLlamadas] = useState([]);
  const [storeConfig, setStoreConfig] = useState(null);
  const [error, setError] = useState(null);

  // 2. Fetch de Configuración (Auto-descubrimiento)
  useEffect(() => {
    const fetchConfig = async () => {
      if (!storeId) {
          // Si llegamos aquí y no tenemos ID, mostramos error
          return;
      }

      try {
        console.log(`Buscando configuración para Tienda ID: ${storeId} en ${DEFAULT_API_URL}...`);
        const response = await axios.get(`${DEFAULT_API_URL}/api/public/store-config/${storeId}`);
        setStoreConfig(response.data);
        console.log("Configuración recibida:", response.data);
      } catch (err) {
        console.error("Error obteniendo configuración de la tienda:", err);
        setError("Error al cargar configuración. Verifique el ID de tienda.");
      }
    };

    fetchConfig();
  }, [storeId]);

  // 3. Conexión WebSocket
  useEffect(() => {
    if (!storeConfig || !storeConfig.wss_url) return;

    let wsUrl = storeConfig.wss_url;

    if (wsUrl.startsWith('https')) {
        wsUrl = wsUrl.replace('https', 'wss');
    } else if (wsUrl.startsWith('http')) {
        wsUrl = wsUrl.replace('http', 'ws');
    }

    console.log(`Intentando conectar WebSocket a: ${wsUrl}`);
    
    let socket;
    let reconnectTimer;

    const connect = () => {
        socket = new WebSocket(wsUrl);

        socket.onopen = () => {
            console.log(`WebSocket Conectado exitosamente a ${storeConfig.name}`);
            setError(null);
        };

        socket.onmessage = (event) => {
            try {
                const nextCall = JSON.parse(event.data);
                console.log("Mensaje WS recibido:", nextCall);

                if (nextCall.status === 'received') return;

                if (Boolean(nextCall.calling)) {
                    setLlamadas(prevArray => [nextCall, ...prevArray.filter(elemento => elemento.name !== nextCall.name)]);
                } else {
                    setLlamadas(prevArray => prevArray.filter(elemento => elemento.name !== nextCall.name));
                }
            } catch (e) {
                console.error("Error al procesar mensaje WS:", e);
            }
        };

        socket.onerror = (error) => {
            console.error("WebSocket Error:", error);
        };

        socket.onclose = (event) => {
            console.log("WebSocket desconectado:", event.reason);
            reconnectTimer = setTimeout(() => {
                console.log("Intentando reconectar...");
                connect();
            }, 5000);
        };
    };

    connect();

    return () => {
        if (socket) socket.close();
        if (reconnectTimer) clearTimeout(reconnectTimer);
    };
  }, [storeConfig]);

  if (!storeId) return <div className="caller-msg error">Error: Falta ID de tienda (Prop: {storeIdProp}, Param: {params.storeId})</div>;
  if (error) return <div className="caller-msg error">{error}</div>;
  if (!storeConfig) return <div className="caller-msg loading">Cargando configuración de Tienda {storeId}...</div>;

  return (
    <>
      <div style={{
        minHeight: "100vh", 
        height: storeIdProp ? "85vh" : "100vh", 
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(to bottom, black, #30beca, #fbcd00)",
        overflow: "hidden",
        position: 'relative'
      }}>
        <div style={{position: 'absolute', top: 10, left: 10, color: 'rgba(255,255,255,0.3)', fontSize: '12px'}}>
            {storeConfig.name}
        </div>

        {llamadas.length > 0 && 
            <CallItemImportant 
                name={llamadas[0]?.name} 
                showing={llamadas[0]?.showing_time} 
                queue_type={llamadas[0]?.queue_type} 
            />
        }
      </div>
    </>
  );
}

export default Caller;
